const colors = {
    primary: '#ac1f40',
    secondary: '#4C0404',
    danger: '#f44336',
    black: '#000000',
    darkGrey: '#353535',
    mediumGrey: '#505050',
    white: '#ffffff',
    softWhite: '#fbf8f8',
    background: '#dedede',
    form: '#e5e5e5',
    pinkLight: '#FFF4F4',
    borderGray: '#B3B3B3',
    buttonGrey: '#B3B3B3',
    subtitle: "#746F6F",
    transparent: '#00000000'
}

export default colors;